import './Avatar.scss';
import { Participant } from './Participants';

interface Props {
  data: Participant;
  className?: string;
  backgroundColor: string;
}

export default function Avatar({
  data,
  className = '',
  backgroundColor,
}: Props) {
  return (
    <div
      className={`Avatar rounded-circle text-white d-flex align-items-center justify-content-center text-uppercase ${className}`}
      style={{
        backgroundColor,
      }}
    >
      {data.Name[0]}
      {data.FamilyName[0]}
    </div>
  );
}
